import React from 'react';
import Head from 'next/head';
import Footer from '../../organisms/Footer';
import HeaderRastreadores from '../../organisms/HeaderRastreadores';
import RastreadoresBannerV2 from '../../organisms/RastreadoresBannerV2';
import RastreadoresOQueEV2 from '../../organisms/RastreadoresOQueEV2/RastreadoresOQueEV2';
import RastreadoresParceriasV2 from '../../organisms/RastreadoresParceriasV2/RastreadoresParceriasV2';
import RastreadoresFormV2 from '../../organisms/RastreadoresFormV2/RastreadoresFormV2';

function Rastreadores() {
  return (
    <>
      <Head>
        <title>Rastreadores para Veículos | Santander Financiamentos</title>
        <meta
          name="Description"
          content="Serviço oferecido pela Santander Financiamentos para a instalação de rastreadores no automóvel que será financiado, gerando maior garantia no processo de financiamento para o lojista e cliente."
        />
        <link
          rel="canonical"
          href="https://www.santander.com.br/hotsite/santanderfinanciamentos/rastreadores.html"
        />
        {/* <!-- OPEN GRAPH TAGS FOR FACEBOOK, WHATSAPP AND LINKEDIN --> */}
        {/* <!-- TWITTER CARDS FOR TWITTER --> */}
      </Head>
      <HeaderRastreadores />
      <RastreadoresBannerV2 />
      {/* <RastreadoresForm /> */}
      <RastreadoresFormV2 />
      <RastreadoresOQueEV2 />
      {/* <RastreadoresParceriasV2 /> */}
      <Footer />
    </>
  );
}

export default Rastreadores;
